import { render, staticRenderFns } from "./ChoseSample.vue?vue&type=template&id=15b817cd&scoped=true"
import script from "./ChoseSample.vue?vue&type=script&lang=js"
export * from "./ChoseSample.vue?vue&type=script&lang=js"
import style0 from "./ChoseSample.vue?vue&type=style&index=0&id=15b817cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b817cd",
  null
  
)

export default component.exports